"use client";

import { useState } from "react";
import { badgeVariants } from "~/components/ui/badge";
import type { PracticeBadgeData } from "~/lib/practice-page-links";
import { PracticeBadge } from "./practice-badge";

const MAX_VISIBLE = 12;

export default function SpecialtyTags({
  specialties,
}: {
  specialties: PracticeBadgeData[];
}) {
  const [showAll, setShowAll] = useState(false);

  const visible = showAll ? specialties : specialties.slice(0, MAX_VISIBLE);
  const hiddenCount = specialties.length - MAX_VISIBLE;

  return (
    <div className="flex flex-wrap gap-2">
      {visible.map((specialty, index) => (
        <PracticeBadge key={`${specialty.href}:${index}`} {...specialty} />
      ))}
      {!showAll && hiddenCount > 0 && (
        <button
          onClick={() => setShowAll(true)}
          className={badgeVariants({
            variant: "outline",
            className: "cursor-pointer",
          })}
        >
          +{hiddenCount} više
        </button>
      )}
    </div>
  );
}
